import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Tooltip, makeStyles } from "@material-ui/core";
import React, { Fragment, useContext, useEffect, useState, useRef } from "react";

import { defaultGridOptions, tooltipDelay, useGridColDefs } from "../../../utils/GridUtils";
import MaterialTable from "material-table";

import { AppContext } from "../../../contexts/AppContext";
import { decodeFile } from "../../../utils/MiscellaneousUtils";
import { LoginContext } from "../../../contexts/LoginContext";
import CustomDatePicker from "../../../components/UI/CustomDatePicker";
import { commonFilter } from "../../../constants/StyleConstants";
import { firstDayMonth, todayDate, todayLastYear, YMD_FORMAT } from "../../../utils/DateUtils";
import moment from "moment";
import DefaultUnrederedGridMessage from "../../../containers/DefaultUnrenderedGridMessage";
import ActivityLogAPI from "../../../services/ActivityLogsAPI";
//import { SOURCETYPES } from "../../../constants/GlobalConstants";

const ActivityLogs = ({ open, setOpen, sourceType }) => {
  const { isSupplier, idSupplier } = useContext(LoginContext);
  const { showError, showWarning } = useContext(AppContext);

  const [firstLoad, setFirstLoad] = useState(true);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [dateFrom, setDateFrom] = useState(isSupplier ? firstDayMonth() : null);
  const [dateTo, setDateTo] = useState(isSupplier ? moment() : null);
  const [oldSearchRequest, setOldSearchRequest] = useState({});
  const [rows, setRows] = useState([]);
  const [loadingActivity, setLoadingActivity] = useState(false);


  useEffect(() => {
    if (open && firstLoad) {
      search();
    } else if (!open) {
      cleanFilters();
      setFirstLoad(true);
      setRows([]);
    }
  }, [open]);

  const cleanFilters = () => {
    setSelectedSupplier(null);
    setDateFrom(null);
    setDateTo(null);
  };

  const search = (reload) => {
    const request = reload
      ? oldSearchRequest
      : {
          startDate: dateFrom ? dateFrom.format(YMD_FORMAT) : undefined,
          endDate: dateTo ? dateTo.format(YMD_FORMAT) : undefined,    
          sourceType: sourceType,      
          exclusionActivityType: 'LogIn;LogOut'
        };

    setOldSearchRequest(request);

    firstLoad && setFirstLoad(false);
    setLoadingActivity(true);

    ActivityLogAPI.get(request)
      .then((res) => setRows(res.data))
      .catch((error) => showError("Error al obtener los registros"))
      .finally(() => setLoadingActivity(false));
  };

  const validateFilters = () => {
    let errors = [];
    const errorMessages = [];
    let i = 0;

    if ((errors[i++] = dateFrom && !dateTo)) {
      errorMessages.push(
        "Debe completar el rango de fechas o quitar la Fecha desde"
      );
    }

    if ((errors[i++] = !dateFrom && dateTo)) {
      errorMessages.push(
        "Debe completar el rango de fechas o quitar la Fecha hasta"
      );
    }

    const hasErrors = errors.some((e) => e);

    hasErrors && showWarning(errorMessages);

    return !hasErrors;
  };

  const validateAndSearch = () => validateFilters() && search();

  const useStyles = makeStyles((theme) => ({
    ...commonFilter,
  }));

  const Filters = () => {
    const classes = useStyles();
    const { isSupplier } = useContext(LoginContext);

    return (
      <div className={classes.filters}>
        <CustomDatePicker
          value={dateFrom}
          maxDate={dateTo}
          label="Fecha desde"
          setValue={setDateFrom}
        />
        <CustomDatePicker
          value={dateTo}
          minDate={dateFrom}
          label="Fecha hasta"
          setValue={setDateTo}
        />
        <div className={classes.filtersActionButton}>
          <Button
            variant="outlined"
            color="primary"
            onClick={validateAndSearch}
          >
            Filtrar
          </Button>
          <Button variant="outlined" color="secondary" onClick={cleanFilters}>
            Limpiar
          </Button>
        </div>
      </div>
    );
  };

  const ActivityLogsModalGrid = () => {
    const { isAllowedByRole } = useContext(LoginContext);
    const tableRef = useRef();

    const colDefs = useGridColDefs([
      {
        title: "Fecha De Actividad",
        field: "date",
        valueType: "date",
        width: "10%",
      },

      {
        title: "Descripción",
        field: "activityDescription",
        width: "60%",
        valueRender: (value) => (
          <Tooltip
            title={value}
            enterDelay={tooltipDelay}
            enterNextDelay={tooltipDelay}
          >
            <span>{value}</span>
          </Tooltip>
        ),
      },
      {
        title: "Usuario",
        field: "userFullName",
        align: "center",
        width: "30%",
      },
    ]);

    return (
      <Fragment>
        <MaterialTable
          {...defaultGridOptions}
          columns={colDefs}
          data={rows}
          tableRef={tableRef}
          options={{
            ...defaultGridOptions.options,
            pageSize:
              tableRef?.current?.dataManager?.pageSize ||
              defaultGridOptions.options.pageSize,
          }}
        />
      </Fragment>
    );
  };

  return (
    <div>
      <Dialog
        maxWidth="md"
        fullWidth={true}
        onClose={() => setOpen(false)}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle
          id="customized-dialog-title"
          onClose={() => setOpen(false)}
        >
          Registro de actividades de requerimiento de certificado de calidad
        </DialogTitle>
        <DialogContent dividers>
          <Filters />
          <DefaultUnrederedGridMessage render={isSupplier || !firstLoad}>
            <ActivityLogsModalGrid />
          </DefaultUnrederedGridMessage>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={() => setOpen(false)} color="secondary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ActivityLogs;
